<div id="academy-courses" class="page-layout simple">
  <!-- CONTENT -->
  <div class="content p-24">
    <div fxLayout="column" fxLayoutAlign="center">
      <app-top-search-bar
        [onSearchCallback]="filterCardsByTerm"
      ></app-top-search-bar>

      <button
        *ngIf="showAddButton"
        mat-fab
        (click)="addBooth()"
        class="add-event-button mat-accent"
        aria-label="Add event"
        [@animate]="{ value: '*', params: { delay: '300ms', scale: '0.2' } }"
      >
        <mat-icon>add</mat-icon>
      </button>

      <div class="courses" fxLayout="row wrap" fxLayoutAlign="center">
        <!-- (scroll)="onScroll($event)"
        style="overflow-y: auto; height: 600px" -->
        <div class="course" fxFlex="100" *ngFor="let booth of filterbooths">
          <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div [style.backgroundColor]="booth.card_color">
              <button
                *ngIf="booth.type === 'G'"
                style="float: right; margin: 2px"
                (click)="selectGender(booth)"
                mat-mini-fab
                color="primary"
                aria-label="Example icon button with a home icon"
              >
                <img
                  style="width: 24px; height: 24px"
                  src="../../../assets/icons/male-female-split.png"
                />
              </button>
              <img
                *ngIf="booth.type == 'M'"
                style="width: 45px; float: right"
                src="../../../assets/images/men.png"
                alt=""
              />
              <img
                *ngIf="booth.type == 'W'"
                style="width: 45px; float: right"
                src="../../../assets/images/women.png"
                alt=""
              />
            </div>

            <div
              (click)="onBoothCardClick(booth)"
              [style.backgroundColor]="booth.card_color"
              class="header"
              fxLayout="column"
            >
              <div class="booth-count">
                <h3
                  style="width: fit-content; font-size: larger; height: 51%"
                  class="badge badge-pill badge-secondary"
                >
                  {{ "booth number" | translate }} : {{ booth.booth_number }}
                </h3>
                <h3
                  style="width: fit-content; font-size: larger; height: 51%"
                  class="badge badge-pill badge-secondary"
                >
                  {{ "Recommend" | translate }} :
                  {{ booth?.post_count_pending }}
                </h3>
                <h3
                  style="width: fit-content; font-size: larger; height: 51%"
                  class="badge badge-pill badge-secondary"
                >
                  {{ "confirm" | translate }} :
                  {{ booth.post_count }}
                </h3>
                <h3
                  style="width: fit-content; font-size: larger; height: 51%"
                  class="badge badge-pill badge-secondary"
                >
                  {{ "recognition" | translate }} :
                  {{ booth.approved }}
                </h3>

                <!-- <mat-slide-toggle style="float: right;" (click)="selectGender()"></mat-slide-toggle> -->
                <!-- <button mat-button style="float: right;" (click)="testing(booth)"></button> -->
                <button
                  (click)="PartypostMemberList(booth)"
                  style="
                    background-color: green;
                    color: white;
                    float: right;
                    width: fit-content;
                    height: 40px;
                  "
                  mat-raised-button
                >
                  கிளை பொறுப்புகள்
                  <!-- <mat-icon aria-hidden="false" aria-label="check icon">cloud_download</mat-icon> -->
                </button>
              </div>
              <div class="title">{{ booth.booth }}</div>
            </div>
            <div class="mid" fxLayout="column">
              <div class="sub-title">{{ booth.area }}</div>
            </div>

            <!-- <mat-expansion-panel (opened)="expandVots(booth)">
              <mat-expansion-panel-header class="expansion_head" [style.backgroundColor]="booth.card_color">
                <mat-panel-title class="mb-24">
                  <div>
                    <p class="m-0 ml-24 droptext">வாக்குகள்</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div [ngStyle]="{
                  'margin-top': getExtraContainerHtml() != '' ? 'auto' : ''
                }" class="footer pt-4 pb-4" fxFlex fxLayout="column" fxLayoutGap="10px"
                fxLayoutAlign="space-between center">
                <div class="container" fxLayout="column" fxLayout.md="row" fxLayoutGap="20px" style="width: 100%">
                  <div class="cardWrap" fxLayout.lt-md="column" fxLayout.md="column" fxLayout="row" fxFlex.md="100"
                    fxLayoutAligmnet="space-between center" fxLayoutGap="20px" *ngFor="let votes of booth?.votesList"
                    style="width: 100% !important">
                    <div *ngFor="let votes of votsList" style="width: 100%;">
                    <div fxFlex.lt-md="100" fxFlex.md="65" fxFlex="40" class="m-0" style="
                        display: flex;
                        justify-content: center;
                        max-height: 70% !important;
                        width: 100%;
                      ">
                      <mat-card class="example-card p-0" fxFlex="100">
                        <div mat-card-avatar fxFlex="25" class="example-header-image">
                          <img (error)="showEmptyImage($event)" src="{{ votes.photo_url }}" alt="" />
                        </div>
                        <div fxFlex="75">
                          <mat-card-title class="p-4 center">{{ votes.member_name }}
                          </mat-card-title>
                          <mat-card-subtitle class="p-4 center">
                            {{ votes.member_id }}
                          </mat-card-subtitle>
                          <mat-card-subtitle class="p-4 center post">
                            #{{ votes.contest_id }}
                          </mat-card-subtitle>
                          <mat-card-subtitle class="p-4 center post">
                            {{ votes.public_post_name }}
                          </mat-card-subtitle>
                        </div>
                      </mat-card>
                    </div>
                    <div fxFlex.lt-md="100" fxLayout="row wrap" fxFlex="60" class="mb-12 center">
                      <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" class="center" fxFlex="90"
                        style="align-items: center">
                        <ng-container>
                          <mat-card class="m-4" fxFlex.lt-sm="100%">
                            <strong> நாம் தமிழர் : </strong><strong class="count">{{ votes.self }}</strong>
                          </mat-card>
                          <mat-card class="m-4" v fxFlex.lt-sm="100%">
                            <strong> எதிரணி 1 : </strong><strong class="count">{{ votes.opp_1 }}</strong>
                          </mat-card>
                          <mat-card class="m-4" fxFlex.lt-sm="100%">
                            <strong> எதிரணி 2 : </strong><strong class="count">{{ votes.opp_2 }}</strong>
                          </mat-card>
                          <mat-card class="m-4" fxFlex.lt-sm="100%">
                            <strong> பதிவான வாக்குகள் : </strong><strong class="count">{{
                              votes.total_votes
                            }}</strong>
                          </mat-card>
                        </ng-container>
                      </div>

                      <div fxFlex="10" class="edit">
                        <mat-icon (click)="edit(booth)">edit</mat-icon>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / CONTENT -->
</div>
